(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["discography-detail"] && !Shopify.designMode) return;
  try {
    
const swiperPhotos = new Swiper('.swiper-photos', {
// Optional parameters
// direction: 'vertical',
loop: false,
allowTouchMove: true,
effect: 'fade',
crossFade: 'true',
spaceBetween: 0,
slidesPerView: 1,
centeredSlides: true,
grabCursor: true,


// If we need pagination
pagination: {
el: '.swiper-pagination',
clickable: true,
},

// Navigation arrows
navigation: {
nextEl: '.swiper-button-next',
prevEl: '.swiper-button-prev',
},

});

const swiperVideos = new Swiper('.swiper-videos', {
// Optional parameters
loop: false,
allowTouchMove: true,
effect: 'slide',
spaceBetween: 0,
slidesPerView: 1,
centeredSlides: true,

// If we need pagination
pagination: {
el: '.swiper-pagination',
clickable: true,
},

// Navigation arrows
navigation: {
nextEl: '.swiper-button-next',
prevEl: '.swiper-button-prev',
},
on: {
slideChange: function() {
// players[mySwiper.previousIndex].pauseVideo();
// players[mySwiper.activeIndex].playVideo();
}
}

});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hoerprobe"] && !Shopify.designMode) return;
  try {
    
/* Standalone Shopify-friendly interaction. This gag intentionally never plays audio. */
(() => {
  if(window.hoerprobeSectionLoaded)return;
  window.hoerprobeSectionLoaded=true;
  function mount(root) {
    if (root.dataset.mounted) return;
    root.dataset.mounted = 'true';
    const area=root.querySelector('.playground'), button=root.querySelector('.play-button');
    const reduced=matchMedia('(prefers-reduced-motion: reduce)');
    const controller=new AbortController(), opts={signal:controller.signal};
    let x=0,y=0,tx=0,ty=0,vx=0,vy=0,w=0,h=0,size=0,raf=0,last=0,lastEscape=-1000,touchFlight=false;
    const clamp=(v,a,b)=>Math.max(a,Math.min(b,v));
    function paint(){
      const speed=Math.hypot(vx,vy),stretch=reduced.matches?0:Math.min(speed*.00013,touchFlight?.12:.075);
      const angle=Math.atan2(vy,vx)*180/Math.PI;
      button.style.transform=`translate3d(${x}px,${y}px,0) rotateX(${reduced.matches?0:clamp(-vy*.015,-12,12)}deg) rotateY(${reduced.matches?0:clamp(vx*.015,-12,12)}deg) rotate(${angle}deg) scale(${1+stretch},${1-stretch}) rotate(${-angle}deg)`;
    }
    function frame(now){
      const dt=Math.min((now-last)/1000||1/60,.032);last=now;
      const spring=touchFlight?260:145, damping=touchFlight?27:20;
      vx+=(spring*(tx-x)-damping*vx)*dt;vy+=(spring*(ty-y)-damping*vy)*dt;
      x=clamp(x+vx*dt,12,Math.max(12,w-size-12));y=clamp(y+vy*dt,12,Math.max(12,h-size-12));paint();
      if(Math.hypot(tx-x,ty-y)>.1||Math.hypot(vx,vy)>.5)raf=requestAnimationFrame(frame);
      else{x=tx;y=ty;vx=vy=0;paint();raf=0}
    }
    function animate(){if(!raf){last=performance.now();raf=requestAnimationFrame(frame)}}
    function measure(){w=area.clientWidth;h=area.clientHeight;size=button.offsetWidth;x=tx=(w-size)/2;y=ty=(h-size)/2;vx=vy=0;paint()}
    function dodge(px,py,explicit=false,touch=false){
      const now=performance.now();if(!explicit&&now-lastEscape<350)return;lastEscape=now;
      // Respect reduced motion; the button still never plays audio.
      if(reduced.matches)return;
      touchFlight=touch;
      const margin=22, maxX=Math.max(margin,w-size-margin), maxY=Math.max(margin,h-size-margin);
      const corners=[[margin,margin],[maxX,margin],[margin,maxY],[maxX,maxY]];
      const available=Math.max(...corners.map(p=>Math.hypot(p[0]-x,p[1]-y)));
      const minTravel=touch?Math.min(size*1.65,available*.85):Math.min(95,Math.min(w,h)*.3);
      const away=Math.atan2(y+size/2-py,x+size/2-px);
      const candidates=[];
      // Continuous angles and distances avoid repeated corner-to-corner flights.
      for(let i=0;i<36;i++){
        const angle=away+(Math.random()-.5)*Math.PI*1.7;
        const distance=touch?minTravel+Math.random()*Math.min(w,h)*.45:Math.min(w,h)*(.3+Math.random()*.48);
        const nx=clamp(x+Math.cos(angle)*distance,margin,maxX);
        const ny=clamp(y+Math.sin(angle)*distance,margin,maxY);
        const travel=Math.hypot(nx-x,ny-y);
        const clearance=Math.hypot(nx+size/2-px,ny+size/2-py);
        if(travel>=minTravel&&clearance>size*.85)candidates.push([nx,ny]);
      }
      if(candidates.length)[tx,ty]=candidates[Math.floor(Math.random()*candidates.length)];
      else{tx=x<(w-size)/2?maxX:margin;ty=y<(h-size)/2?maxY:margin;}
      const heading=Math.atan2(ty-y,tx-x),side=Math.random()<.5?-1:1;
      // A small sideways impulse curves the spring trajectory without teleporting.
      if(touch){
        // Launch immediately away from the finger, then let the spring brake.
        const launch=Math.min(1400,Math.hypot(tx-x,ty-y)*5);
        vx=Math.cos(heading)*launch+Math.cos(heading+side*Math.PI/2)*130;
        vy=Math.sin(heading)*launch+Math.sin(heading+side*Math.PI/2)*130;
      }else{
        vx+=Math.cos(heading+side*Math.PI/2)*160;
        vy+=Math.sin(heading+side*Math.PI/2)*160;
      }
      animate();
    }
    area.addEventListener('pointermove',e=>{if(e.pointerType!=='mouse'||reduced.matches||button.matches(':focus-visible'))return;const r=area.getBoundingClientRect(),px=e.clientX-r.left,py=e.clientY-r.top;if(Math.hypot(px-x-size/2,py-y-size/2)<size/2+85)dodge(px,py)},opts);
    button.addEventListener('pointerdown',e=>{const r=area.getBoundingClientRect();dodge(e.clientX-r.left,e.clientY-r.top,true,e.pointerType==='touch'||e.pointerType==='pen')},opts);
    button.addEventListener('click',e=>{e.preventDefault();if(e.detail===0)dodge(x+size/2,y+size/2,true)},opts);
    reduced.addEventListener('change',()=>{if(reduced.matches){cancelAnimationFrame(raf);raf=0;vx=vy=0;x=tx;y=ty;paint()}},opts);
    const observer=new ResizeObserver(measure);observer.observe(area);measure();
    root.cleanup=()=>{controller.abort();observer.disconnect();cancelAnimationFrame(raf);delete root.dataset.mounted};
  }
  document.querySelectorAll('[data-album-teaser]').forEach(mount);
  document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('[data-album-teaser]').forEach(mount));
  document.addEventListener('shopify:section:unload',e=>e.target.querySelectorAll('[data-album-teaser]').forEach(root=>root.cleanup?.()));
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lightgallery"] && !Shopify.designMode) return;
  try {
    
// window.lightGalleryElements is used to track already initialized elements.
// Without this elements may be initialized multiple times if this section is used multiple times on a page.
// This would be no problem if {{ section.id }} would work inside this javascript section.

const lightGalleryElements = document.querySelectorAll('.lightgallery-content');

for (let element of lightGalleryElements) {

if (!window.lightGalleryElements)
window.lightGalleryElements = [];

if (window.lightGalleryElements.indexOf(element) > -1)
continue;

fjGallery(element, {
itemSelector: '.gallery-item',
rowHeight: 120,
lastRow: 'center',
gutter: 10,
rowHeightTolerance: 0.1,
calculateItemsHeight: false,
});
lightGallery(element, {
thumbnail: true,
thumbHeight: '160px',
plugins: [lgZoom, lgThumbnail],
subHtmlSelectorRelative: true,
licenseKey: 'EBAB8A39-2DBA-4861-B8A8-7328FFB2CA45',
});
window.lightGalleryElements.push(element);

}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lightgallery_hardcoded_bettina_bis_Hildegard"] && !Shopify.designMode) return;
  try {
    
// window.lightGalleryElements is used to track already initialized elements.
// Without this elements may be initialized multiple times if this section is used multiple times on a page.
// This would be no problem if {{ section.id }} would work inside this javascript section.
const lightGalleryElements = document.querySelectorAll('.lightgallery-content');
for (let element of lightGalleryElements) {
if (!window.lightGalleryElements)
window.lightGalleryElements = [];
if (window.lightGalleryElements.indexOf(element) > -1)
continue;
fjGallery(element, {
itemSelector: '.gallery-item',
rowHeight: 120,
lastRow: 'center',
gutter: 10,
rowHeightTolerance: 0.1,
calculateItemsHeight: false,
});
lightGallery(element, {
thumbnail: true,
thumbHeight: '160px',
plugins: [lgZoom, lgThumbnail],
subHtmlSelectorRelative: true,
licenseKey: 'EBAB8A39-2DBA-4861-B8A8-7328FFB2CA45',
});
window.lightGalleryElements.push(element);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lightgallery_hardcoded_detektiv_bis_villa"] && !Shopify.designMode) return;
  try {
    
// window.lightGalleryElements is used to track already initialized elements.
// Without this elements may be initialized multiple times if this section is used multiple times on a page.
// This would be no problem if {{ section.id }} would work inside this javascript section.
const lightGalleryElements = document.querySelectorAll('.lightgallery-content');
for (let element of lightGalleryElements) {
if (!window.lightGalleryElements)
window.lightGalleryElements = [];
if (window.lightGalleryElements.indexOf(element) > -1)
continue;
fjGallery(element, {
itemSelector: '.gallery-item',
rowHeight: 120,
lastRow: 'center',
gutter: 10,
rowHeightTolerance: 0.1,
calculateItemsHeight: false,
});
lightGallery(element, {
thumbnail: true,
thumbHeight: '160px',
plugins: [lgZoom, lgThumbnail],
subHtmlSelectorRelative: true,
licenseKey: 'EBAB8A39-2DBA-4861-B8A8-7328FFB2CA45',
});
window.lightGalleryElements.push(element);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lightgallery_hardcoded_sprechblasen"] && !Shopify.designMode) return;
  try {
    
// window.lightGalleryElements is used to track already initialized elements.
// Without this elements may be initialized multiple times if this section is used multiple times on a page.
// This would be no problem if {{ section.id }} would work inside this javascript section.
const lightGalleryElements = document.querySelectorAll('.lightgallery-content');
for (let element of lightGalleryElements) {
if (!window.lightGalleryElements)
window.lightGalleryElements = [];
if (window.lightGalleryElements.indexOf(element) > -1)
continue;
fjGallery(element, {
itemSelector: '.gallery-item',
rowHeight: 120,
lastRow: 'center',
gutter: 10,
rowHeightTolerance: 0.1,
calculateItemsHeight: false,
});
lightGallery(element, {
thumbnail: true,
thumbHeight: '160px',
plugins: [lgZoom, lgThumbnail],
subHtmlSelectorRelative: true,
licenseKey: 'EBAB8A39-2DBA-4861-B8A8-7328FFB2CA45',
});
window.lightGalleryElements.push(element);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lightgallery_hardcoded_vincent_bis_justin"] && !Shopify.designMode) return;
  try {
    
// window.lightGalleryElements is used to track already initialized elements.
// Without this elements may be initialized multiple times if this section is used multiple times on a page.
// This would be no problem if {{ section.id }} would work inside this javascript section.
const lightGalleryElements = document.querySelectorAll('.lightgallery-content');
for (let element of lightGalleryElements) {
if (!window.lightGalleryElements)
window.lightGalleryElements = [];
if (window.lightGalleryElements.indexOf(element) > -1)
continue;
fjGallery(element, {
itemSelector: '.gallery-item',
rowHeight: 120,
lastRow: 'center',
gutter: 10,
rowHeightTolerance: 0.1,
calculateItemsHeight: false,
});
lightGallery(element, {
thumbnail: true,
thumbHeight: '160px',
plugins: [lgZoom, lgThumbnail],
subHtmlSelectorRelative: true,
licenseKey: 'EBAB8A39-2DBA-4861-B8A8-7328FFB2CA45',
});
window.lightGalleryElements.push(element);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lightgallery_hardcoded_wohnung_bis_park"] && !Shopify.designMode) return;
  try {
    
// window.lightGalleryElements is used to track already initialized elements.
// Without this elements may be initialized multiple times if this section is used multiple times on a page.
// This would be no problem if {{ section.id }} would work inside this javascript section.
const lightGalleryElements = document.querySelectorAll('.lightgallery-content');
for (let element of lightGalleryElements) {
if (!window.lightGalleryElements)
window.lightGalleryElements = [];
if (window.lightGalleryElements.indexOf(element) > -1)
continue;
fjGallery(element, {
itemSelector: '.gallery-item',
rowHeight: 120,
lastRow: 'center',
gutter: 10,
rowHeightTolerance: 0.1,
calculateItemsHeight: false,
});
lightGallery(element, {
thumbnail: true,
thumbHeight: '160px',
plugins: [lgZoom, lgThumbnail],
subHtmlSelectorRelative: true,
licenseKey: 'EBAB8A39-2DBA-4861-B8A8-7328FFB2CA45',
});
window.lightGalleryElements.push(element);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["restricted_media_library"] && !Shopify.designMode) return;
  try {
    

// window.lightGalleryElements is used to track already initialized elements.
// Without this elements may be initialized multiple times if this section is used multiple times on a page.
// This would be no problem if {{ section.id }} would work inside this javascript section.

const lightGalleryElements = document.querySelectorAll('.video-section__poster-desktop');

for (let element of lightGalleryElements) {

if (!window.lightGalleryElements)
window.lightGalleryElements = [];

if (window.lightGalleryElements.indexOf(element) > -1)
continue;

lightGallery(element, {
mode: 'lg-fade',
selector: 'this',
animateThumb: false,
zoomFromOrigin: false,
enableSwipe:false,
swipeToClose: false,
appendCounterTo: null,
plugins: [lgVideo],
licenseKey: 'EBAB8A39-2DBA-4861-B8A8-7328FFB2CA45',
});

window.lightGalleryElements.push(element);

}


  } catch(e) { console.error(e); }
})();
})();
